exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 1024px){.mobile-only[data-v-311a0d5b]{display:none !important}}@media (max-width: 1023px){.desktop-only[data-v-311a0d5b]{display:none !important}}.product__review[data-v-311a0d5b]{padding-bottom:24px;border-bottom:var(--c-light) solid 1px;margin-bottom:var(--spacer-base)}.product__review[data-v-311a0d5b]:last-of-type{border:none;padding-bottom:0;margin-bottom:0}@media (min-width: 1024px){.product__review[data-v-311a0d5b]{padding-bottom:0}}.product__reviews-pagination[data-v-311a0d5b]{margin:var(--spacer-lg) 0 0}.m-review-list[data-v-311a0d5b]{margin-top:var(--spacer-base)}\n", ""]);

// exports
